export function dropDownOptions(optionsData) {
    return (<>
        {optionsData?.map((code) => {
            return {
                value: code.Id + "," + code.Name,
                label: (
                    <>
                        <span>{code.Name}</span>
                    </>
                )
            }
        })}
    </>)
}

export function dropDownOptionsTrainings(optionsData) {
    return (<>
        {optionsData?.map((code) => {
            return {
                value: code.Id + "," + code.Name,
                label: (
                    <>
                        <span>{code.Name}</span>
                    </>
                ),
                role: code.YardAdditionalRoles
            }
        })}
    </>)
}

export const characterValidation = (string) => {
    const pattern = /^[a-zA-Z0-9\s]*$/;
    return pattern.test(string)
}

